import request from './request';
import SparkMD5 from 'spark-md5';

// 密码登录接口
export function login(data) {
  return request({
    url: '/mail/login/password',  // 修改为更常见的登录路径
    method: 'post',
    data: {
      username: data.username, // 将手机号作为用户名
      password: data.password,
    }
  });
}

// 短信验证码登录接口
export function loginBySms(data) {
  return request({
    url: '/mail/login/sms',
    method: 'post',
    data: {
      phone: data.phone,
      sms_code: data.sms_code
    }
  });
}

// 获取图形验证码
export function getCaptcha() {
  return request({
    url: '/mail/tools/captcha',
    method: 'get',
    responseType: 'json'
  });
}

// 发送短信验证码
export function sendSms(data) {
  return request({
    url: '/mail/tools/sms',
    method: 'post',
    data
  });
}

// 忘记密码接口
export function forgetPassword(data) {
  return request({
    url: '/mail/forget_password',
    method: 'post',
    data
  });
}

// 计算文件md5
export function getFileMd5(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = e => {
      const md5 = SparkMD5.ArrayBuffer.hash(e.target.result);
      resolve(md5);
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
}

// 获取签名
export async function getUploadSignature({ filename, filemd5, file_type, biz_type }) {
  return request.post('/mail/storage/signature', {
    filename,
    filemd5,
    file_type,
    biz_type
  });
}

// 直传图片到云存储
export async function uploadToCloud(upload_url, file, headers) {
  const res = await fetch(upload_url, {
    method: 'PUT', // 或POST，视后端要求
    headers,
    body: file
  });
  if (!res.ok) throw new Error('直传失败');
  return true;
}

// 封装整体上传流程
export async function uploadImageWithSignature(file, biz_type = 'avatar') {
  const filemd5 = await getFileMd5(file);
  const filename = file.name;
  const file_type = 'image';
  // 1. 获取签名
  const signRes = await getUploadSignature({ filename, filemd5, file_type, biz_type });
  // 2. 直传
  await uploadToCloud(signRes.upload_url, file, signRes.upload_headers);
  // 3. 返回图片url
  return signRes.file_url;
}

// 充值卡充值接口
export function rechargeByCard({ card_number, card_password }) {
  return request({
    url: '/mail/recharge/card',
    method: 'post',
    data: {
      card_number,
      card_password
    },
    needAuth: true
  });
}

// 平台跳转登录接口
export function jumpLogin(data) {
  return request({
    url: '/mail/jump_login',
    method: 'post',
    data
  });
}

// 【旅拍机H5页面】获取存储签名（签发对象存储临时密钥）
export function getStoreAppStorageSignature({ filename, filemd5, file_type, biz_type, method, duid }) {
  return request({
    url: '/store_app/storage/signature',
    method: 'post',
    data: {
      filename,
      filemd5,
      file_type,
      biz_type,
      method,
      duid
    },
    needAuth: true
  });
}

// 【旅拍机H5页面】跨设备获取文件地址
export function getStoreAppStorageDevice(duid) {
  return request({
    url: `/store_app/storage/device/${duid}`,
    method: 'get',
    needAuth: true
  });
}
